import ApiService from "../ApiService";

const { REACT_APP_REST_ENDPOINT } = process.env;

/**
 * SafetyDocumentiService
 * Client API per l'archivio documentale (livello azienda e lavoratore) del
 * modulo "Gestione Adempimenti Sicurezza".
 */
export default class SafetyDocumentiService {
    /** Catalogo tipi documento (opz. ambito = "AZIENDA" | "LAVORATORE", settore). */
    static getTipi = (ambito = "", settore = "") => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/documenti/tipi`;
            const payload = {};
            if (ambito) payload.ambito = ambito;
            if (settore) payload.settore = settore;
            ApiService.postRequest(resolve, reject, url, payload);
        });
    };

    /** Documenti a livello azienda. */
    static byAzienda = (id_azienda) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/documenti/byAzienda`;
            ApiService.postRequest(resolve, reject, url, { id_azienda });
        });
    };

    /** Documenti a livello lavoratore. */
    static byLavoratore = (id_lavoratore) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/documenti/byLavoratore`;
            ApiService.postRequest(resolve, reject, url, { id_lavoratore });
        });
    };

    /**
     * Crea un documento con eventuale file.
     * @param {FormData} formData campi: ambito, id_azienda | id_lavoratore,
     *        id_tipo_doc, titolo, numero_protocollo, ente_emittente,
     *        data_emissione, data_scadenza, periodicita_mesi, note, file
     */
    static create = (formData) => {
        const url = `${REACT_APP_REST_ENDPOINT}/safety/documenti/create`;
        return ApiService.postFormData(url, formData);
    };

    /** Elimina (soft) un documento. */
    static deleteDocumento = (id_documento) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/documenti/delete`;
            ApiService.postRequest(resolve, reject, url, { id_documento });
        });
    };

    /** Scarica il file di un documento. */
    static download = (id_documento, filename) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/documenti/download`;
            ApiService.postRequestWithDownload(resolve, reject, url, { id_documento, filename });
        });
    };
}
